import { builder } from '@builder.io/react';
import themeHarrys from '../gatsby-plugin-theme-ui';
import themeLume from '../gatsby-plugin-theme-ui-lume';
import themeMando from '../gatsby-plugin-theme-ui-mando';
import themeHaven from '../gatsby-plugin-theme-ui-haven';
import themeSpruce from '../gatsby-plugin-theme-ui-spruce';

/**
 * Detect brand from URL path or host (for use when theme context is unavailable, e.g. portaled UI).
 * @returns {'kelly'|'spruce'} Brand key; defaults to 'kelly'.
 */
export function getBrandFromPath() {
  if (typeof window === 'undefined') return 'kelly';
  const path = window.location.pathname || '';
  const host = (window.location.hostname || '').toLowerCase();
  // Domain-based: Kelly (Haven), Spruce
  if (host === 'www.havenhealthmd.com' || host === 'havenhealthmd.com') return 'kelly';
  if (host === 'www.myspruceboost.com' || host === 'myspruceboost.com') return 'spruce';
  // Path-based (e.g. Netlify / deploy previews)
  if (path.includes('/spruce/')) return 'spruce';
  if (path.includes('/kelly/')) return 'kelly';
  return 'kelly';
}

const getTheme = () => {
  var theme;
  switch (builder.editingModel) {
    case 'kelly':
      theme = themeHaven;
      break;
    case 'lume-marketing-page':
      theme = themeLume;
      break;
    case 'mando-marketing-page':
      theme = themeMando;
      break;
    case 'spruce-marketing-page':
      theme = themeSpruce;
    default:
      theme = themeHarrys;
  }
  return theme;
}

export default getTheme();
